import React from "react";
import PropTypes from "prop-types";
import { Carousel } from "react-responsive-carousel";
import { Segmant } from "../../components";

const Gallery = ({
  imageData,
  toggle,
  street,
  openpopup,
  page,
  onstreetclick,
  onmapclick,
}) => {
  if (imageData && imageData.length > 0) {
    let icons = process.env.NEXT_PUBLIC_CDN_ID + "static/images/icon.jpg";
    //street ? imageData.push(icons) : null;
    let length = imageData.length;
    async function getMeta(url, id) {
      let w;
      let h;
      let img = new Image();
      img.src = url;
      img.onload = function () {
        w = this.width;
        h = this.height;
        if (h > w || h === w) {
          document.getElementById(id).style.width = "auto";
        } else {
          document.getElementById(id).style.width = "100%";
          document.getElementById(id).style.height = "100%";
        }
      };
    }
  }
  return (
    <div>
      <Segmant className="slider_segment">
        {street ? (
          <>
            <Carousel
              showIndicators={false}
              infiniteloop={true}
              autoPlay={false}
              interval={2000}
              onClickThumb={(e) => toggle(e, length)}
              onClickItem={(e) => openpopup(e, length)}
            >
              {imageData &&
                imageData.length > 0 &&
                imageData.map((image, index) => {
                  let imgid = `imgdatahome${index}`;
                  //let end = getMeta(image, imgid);
                  return (
                    <div key={index}>
                      <img
                        src={image}
                        id={`imgdatahome${index}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            process.env.NEXT_PUBLIC_CDN_ID +
                            "static/images/homedefault.jpg";
                        }}
                        alt="Home"
                        title="Home"
                      />
                    </div>
                  );
                })}
            </Carousel>
            {page === "detailslisting" && (
              <div className="extra_btn">
                <button className="map_str_btn" onClick={() => onmapclick()}>
                  <div className="btn_main">
                    <div>
                      <svg
                        class="map-street-icon"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M21.724,6.053l-6-3a.5.5,0,0,0-.448,0L9.5,5.941,3.724,3.053A.5.5,0,0,0,3,3.5v14a.5.5,0,0,0,.276.447l6,3a.5.5,0,0,0,.448,0L15.5,18.059l5.776,2.888A.5.5,0,0,0,22,20.5V6.5A.5.5,0,0,0,21.724,6.053ZM10,6.809l5-2.5V17.191l-5,2.5Zm-6-2.5,5,2.5V19.691l-5-2.5ZM21,19.691l-5-2.5V4.309l5,2.5Z"
                          fill-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <div>Map</div>
                  </div>
                </button>
                <button className="map_str_btn" onClick={() => onstreetclick()}>
                  <div className="btn_main">
                    <div>
                      <svg
                        class="map-street-icon"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M8.43,18.988h7.0869a.5.5,0,0,0,.5-.5V13.0193a4.0435,4.0435,0,1,0-8.0869,0V18.488A.5.5,0,0,0,8.43,18.988Zm.5-5.9687a3.0435,3.0435,0,1,1,6.0869,0V17.988H8.93Z M19.3435,15.2917a.5.5,0,0,0-.3838.9239c1.2969.539,2.04,1.2011,2.04,1.8154,0,1.3994-3.6963,2.959-9,2.959s-9-1.56-9-2.959c0-.6045.7241-1.2578,1.9863-1.793a.5.5,0,0,0-.39-.9209C2.4509,16.2263,2,17.2947,2,18.031c0,2.5713,5.1519,3.959,10,3.959s10-1.3877,10-3.959C22,17.2859,21.5388,16.2048,19.3435,15.2917Z M11.9734,8.4958A3.2432,3.2432,0,1,0,8.7307,5.2527,3.2432,3.2432,0,0,0,11.9734,8.4958Zm0-5.4863A2.2431,2.2431,0,1,1,9.7307,5.2527,2.2434,2.2434,0,0,1,11.9734,3.01Z"
                          fill-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <div>Street View</div>
                  </div>
                </button>
              </div>
            )}
          </>
        ) : (
          <Carousel
            showIndicators={false}
            infiniteloop={true}
            autoPlay={false}
            interval={2000}
            onClickItem={(e) => openpopup(e, length)}
          >
            {imageData &&
              imageData.length > 0 &&
              imageData.map((image, index) => {
                let imgid = `imgdatahome${index}`;
                //let end = getMeta(image, imgid);
                return (
                  <div key={index}>
                    <img
                      src={image}
                      id={`imgdatahome${index}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }}
                      alt="Home"
                      title="Home"
                    />
                  </div>
                );
              })}
          </Carousel>
        )}
      </Segmant>
    </div>
  );
};

Gallery.propTypes = {
  imageData: PropTypes.array.isRequired,
  button: PropTypes.bool,
};
export default Gallery;
